import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const state = {//要设置的全局访问的state对象
    isLoad: false, //加载动画
    bank: '',
    area_code: '',
    newCont: {},
    bankInfo: {},
    usdtInfo: {},
    btcInfo: {}
};
const mutations = {
    bankSelect(state, payload) {
        state.bank = payload.bank
    },
    codeSelect(state, payload) {
        state.area_code = payload.area_code
    },
    newSelect(state, payload) {
        state.newCont = payload.newCont
    },
    bankInfo(state, payload) {
        state.bankInfo = payload.bankInfo
    },
    usdtInfo(state, payload) {
        state.usdtInfo = payload.usdtInfo
    },
    btcInfo(state, payload) {
        state.btcInfo = payload.btcInfo
    },
    load(state, load) {
        state.isLoad = load.isLoad
    }
};

const store = new Vuex.Store({
    state,
    mutations
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js